import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductionProcess, ProductionProcessDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductionProcessService extends TmsWebBaseEditService<ProductionProcess, ProductionProcessDetails> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('ProductionProcess', $localize`Production Process`, httpService, notificationService);
  }
}
